module.exports = __webpack_public_path__ + "static/media/video-image.08393608.jpg";